import { ALERT_SEVERITY, ERROR_MESSAGES, ROLE_TYPE } from 'eebac/constants';
import { Catch } from '../api_exception';
import { setGlobalMessage, setLoading } from '../app';
const BASE_PATH = 'COMPANY_SUBSCRIPTIONS';

export const SET_SUBSCRIPTION_DATA = `${BASE_PATH}/SET_SUBSCRIPTION_DATA`;
export const SET_SUBSCRIPTION_PLAN = `${BASE_PATH}/SET_SUBSCRIPTION_PLAN`;
export const SET_DATA = `${BASE_PATH}/SET_DATA`;

export const loadCompanySubscriptions = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        dispatch(setPlans([]));
        dispatch(setPlan(null));

        client.get('/company/subscriptions').
            then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.plans) {
                    dispatch(setPlans(result.data.plans));
                    dispatch(setPlan(result.data.plan));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const getPaymentgatewayData = (planId, gstNumber) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.post(`/company/payment/data`, {
            gstNumber: gstNumber,
            planId: planId
        }).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.gatewayData) {
                    dispatch(setData([{ key: "gatewayData", value: result.data.gatewayData }]));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const getInvoice = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));
        dispatch(setData([{ key: "isInvocieLoaded", value: true }]));

        client.get(`/company/invoice/${id}`).
            then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.invoice) {
                    dispatch(setData([{ key: "invoice", value: result.data.invoice }]));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const setData = (data) => ({
    type: SET_DATA,
    data
});

export const setPlans = (plans) => ({
    type: SET_SUBSCRIPTION_DATA,
    plans
});

export const setPlan = (plan) => ({
    type: SET_SUBSCRIPTION_PLAN,
    plan
});

const initialState = {
    plans: [],
    gatewayData: null,
    invoice: null,
    isInvocieLoaded : false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_SUBSCRIPTION_DATA:
            return {
                ...state,
                plans: action.plans
            }
        case SET_SUBSCRIPTION_PLAN:
            return {
                ...state,
                plan: action.plan
            }
        case SET_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
    }
    return state;
}